import React, {useState} from "react";
import styles from './Gallery.module.scss';
import ArrowLeftRoundedIcon from '@material-ui/icons/ArrowLeftRounded';
import ArrowRightRounded from '@material-ui/icons/ArrowRightRounded';
import ImageGallery from 'react-image-gallery';
import classNames from "classnames";

interface IGalleryAsset {
  original: string;
  thumbnail: string;
  originalAlt: string;
  thumbnailAlt: string;
}

export interface IGalleryProps {
  overlay: any;
  overlayClassName?: string;
  galleryOverrides?: any;
  images: IGalleryAsset[];
  width?: number;
}

const Gallery = (props: IGalleryProps) => {
  const [isInfoShown, setShowInfo] = useState(true);
  return (<ImageGallery
    showFullscreenButton={true}
    useBrowserFullscreen={true}
    showPlayButton={false}
    slideInterval={0}
    slideDuration={0}
    lazyLoad={true}
    showIndex={false}
    showThumbnails={true}
    showBullets={false}
    showNav={true}
    thumbnailPosition={props.width <= 680 ? "bottom" : "right"}
    items={props.images}
    renderLeftNav={(onClick) => (<div className={`${styles.sideNav} ${styles.leftSideNav}`}>
      <ArrowLeftRoundedIcon onClick={onClick}/>
    </div>)}
    renderRightNav={(onClick) => (<div className={`${styles.sideNav} ${styles.rightSideNav}`}>
      <ArrowRightRounded onClick={onClick}/>
    </div>)}
    renderOverlay={() => props.overlay ? (
      <div className={`overlay ${styles.overlay} ${isInfoShown ? `shown ${styles.shown}` : ''}`.trim()}>
        <div className={classNames({
          [styles.overlayContent]: true,
          [props.overlayClassName]: !!props.overlayClassName,
        })}>
          {props.overlay}
        </div>
        <div
          className={`grabbableContainer ${styles.grabbableContainer}`}
          onClick={() => setShowInfo(!isInfoShown)}
        >
          <div
            className={styles.grabbable}
          />
        </div>
      </div>) : <div className={`overlay ${styles.overlay} ${styles.noContent}`.trim()}/>}
    render
    {...props.galleryOverrides}

  />)
};
Gallery.defaultProps = {
  width: window.innerWidth,
};

export default Gallery;
